import React, { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { AiOutlineRight } from 'react-icons/ai';
import { LiveBlock } from '../../../live/components/LiveBlock/LiveBlock';
import { LIVE_COUNT_MAX } from '../../constants/topPageConst';
import { IResponseLive } from '../../../../services/api/models/response/responseLive';
import emptyImage from '../../../../assets/png/liver_mihaishin.png';
import './BlockGroup.scss';
import {
  ILiveRenderListTitle,
  LeagueLiveType,
  MethodLiveType,
  VoiceLiveType,
  optionGlobal,
} from '../../../../common/constants/globalConstants';
import {
  useGetListLiveMutation,
  useGetListUserStreamsMutation,
} from '../../../../services/api/apiService/liveApiService';
import { ResponseUserStream } from '../../../../services/api/models/response/responseUserStream';
import UserStreamBlock from '../../../live/components/UserStreamBlock/UserStreamBlock';

interface BlockGroupProps {
  league: ILiveRenderListTitle;
  isTopBlock?: boolean;
}

export const BlockGroup = (props: BlockGroupProps): ReactElement => {
  const { t } = useTranslation();

  const [liveList, setLiveList] = useState<Array<IResponseLive>>([]);
  const [userStreamList, setUserStreamList] = useState<
    Array<ResponseUserStream>
  >([]); // list user not streaming
  const [loading, setLoading] = useState<boolean>();
  const [getListLive] = useGetListLiveMutation();
  const width = window.innerWidth;
  const [getListUserStream] = useGetListUserStreamsMutation();

  useEffect(() => {
    getLivesData();
    if (props.isTopBlock) {
      getListUserStreamData();
    }
  }, []);

  const getLivesData = async () => {
    setLoading(true);
    if (props.league.type === MethodLiveType.ROOKIES) {
      const data = await getListLive({
        method: MethodLiveType.ROOKIES,
        league: LeagueLiveType.ANY,
        voice: VoiceLiveType.ANY,
      }).unwrap();
      setLiveList(data);
    } else if (props.league.type === MethodLiveType.CLOVER) {
      const data = await getListLive({
        method: MethodLiveType.CLOVER,
        league: LeagueLiveType.ANY,
        voice: VoiceLiveType.ANY,
      }).unwrap();
      setLiveList(data);
    } else {
      const data = await getListLive({
        numOfPage: optionGlobal.numOfPage,
        numInPage: optionGlobal.numInPage,
        method: MethodLiveType.ATTENTION,
        league: LeagueLiveType.ANY,
        voice: VoiceLiveType.ANY,
      }).unwrap();
      setLiveList(data);
    }
    setLoading(false);
  };

  //get list user not streaming
  const getListUserStreamData = async () => {
    const data = await getListUserStream({
      method: MethodLiveType.ATTENTION,
      numOfPage: optionGlobal.numOfPage,
      numInPage: optionGlobal.numInPage,
    }).unwrap();
    setUserStreamList(data);
  };

  const renderList = () => {
    if (loading) {
      return (
        <div className="block-group__loading">
          <Spinner
            animation="border"
            style={{ color: 'var(--color-primary)' }}
          />
        </div>
      );
    }
    if (!liveList || liveList.length <= 0) {
      return (
        <div className="block-group__empty">
          <img src={emptyImage} alt="empty-image" />
        </div>
      );
    }

    if (props.league.name === '注目') {
      return (
        <>
          {liveList.map((live) => {
            return (
              <div key={live.id}>
                <LiveBlock live={live} />
              </div>
            );
          })}
          {userStreamList.map((user) => {
            return (
              <div key={user.id}>
                <UserStreamBlock user={user} />
              </div>
            );
          })}
        </>
      );
    }

    return liveList.slice(0, LIVE_COUNT_MAX).map((live) => {
      return (
        <div key={live.id}>
          <LiveBlock live={live} />
        </div>
      );
    });
  };
  return (
    <>
      {liveList.length > 0 && (
        <div className="block-group">
          {props.league.name === '注目' ? (
            <>
              {' '}
              {width < 560 && (
                <div className="block-group__header">
                  <span className="block-group__header-title">注目</span>
                </div>
              )}
            </>
          ) : (
            <div className="block-group__header">
              <span className="block-group__header-title">
                {props.league.name}
              </span>
              <div className="block-group__header-link">
                <Link to={props.league.link || ''}>
                  {t('More')}
                  <AiOutlineRight style={{ marginLeft: 5 }} />
                </Link>
              </div>
            </div>
          )}
          <div className="block-group__body">{renderList()}</div>
        </div>
      )}
    </>
  );
};
